/**
 * ChatResponseFeedback enum constant.
 */
export default {
    notSet: 0,
    like: 1,
    dislike: 2
}